








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'
import UiCopyInput from '@/components/ui/ui-copy-input.vue';

@Component({
  components: {
    UiCopyInput,
    Card,
  }
})
export default class StorybookCopyInput extends Vue {
  text: string = '';

  get testUrl() {
    return 'http://testurl.com'
  }
}
